import { IApiConfig } from "@hopper-b2b/types";

export const PATH_HOME = "/";
// TODO: remove temporary basic auth once ready (see https://hopper-jira.atlassian.net/browse/BP-98)
export const PATH_BASIC_AUTH = PATH_HOME + "basicAuth/";
export const PATH_DEALS_FLIGHTS = "deals/flights/";
export const PATH_DEALS_OFFERS = "deals/offers/";
export const PATH_FLIGHTS = "flights/";
export const PATH_FLIGHTS_SHOP = "flights/shop/";
export const PATH_FLIGHTS_SHOP_PLATFORM = "air/shop/";
export const PATH_FLIGHTS_BOOK = PATH_FLIGHTS + "book/";
export const PATH_FLIGHTS_EXCHANGE = PATH_FLIGHTS + "exchange/";
export const PATH_FLIGHTS_FREEZE = PATH_FLIGHTS + "freeze/";
export const PATH_FLIGHTS_FREEZE_PURCHASE = PATH_FLIGHTS_FREEZE + "purchase/";
export const PATH_FLIGHTS_FREEZE_OVERVIEW = PATH_FLIGHTS_FREEZE + "overview/";
export const PATH_FLIGHTS_SEARCH = PATH_FLIGHTS + "search/";
export const PATH_FLIGHTS_BOOK_CONFIRMATION = PATH_FLIGHTS_BOOK + "confirm/";
export const PATH_HOTELS = "hotels/*";
export const PATH_HOTELS_ROOT = "hotels/";
export const PATH_HOTELS_BOOK_AVAILABILITY = PATH_HOTELS_ROOT + "availability/";
export const PATH_HOTELS_SHOP = PATH_HOTELS_ROOT + "shop/";
export const PATH_HOTELS_SHOP_DETAILS = PATH_HOTELS_SHOP + ":hotelName/";
export const PATH_HOTELS_BOOK = PATH_HOTELS_ROOT + "book/";
export const PATH_HOTELS_NEW_CONFIRMATION = PATH_HOTELS_ROOT + "confirmation";
export const PATH_HOTELS_SEARCH = PATH_HOTELS + "search/";
export const PATH_HOTELS_BOOK_CONFIRMATION = PATH_HOTELS_BOOK + "confirm/";
export const PATH_STAYS = "stays/*";
export const PATH_STAYS_ROOT = "stays/";
export const PATH_STAYS_AVAILABILITY = PATH_STAYS_ROOT + "availability/";
export const PATH_STAYS_SEARCH = PATH_STAYS_ROOT + "search/";
export const PATH_PACKAGES = "packages/*";
export const PATH_PACKAGES_ROOT = "packages/";
export const PATH_PACKAGES_GO_SEARCH = "go/packages/search/";
export const PATH_CRUISES_GO_SEARCH = "go/cruises/search/";
export const PATH_HOMES = "homes/*";
export const PATH_HOMES_ROOT = "homes/";
export const PATH_HOMES_SHOP = PATH_HOMES_ROOT + "shop/";
export const PATH_HOMES_SHOP_DETAILS = PATH_HOMES_ROOT + "shop/:listingName/";
export const PATH_HOMES_BOOK = PATH_HOMES_ROOT + "book/";
export const PATH_CARS = PATH_HOME + "cars/";
export const PATH_CARS_SEARCH = PATH_CARS + "search/";
export const PATH_CARS_AVAILABILITY = PATH_CARS + "availability/";
export const PATH_CARS_BOOK = `${PATH_CARS}book/`;
export const PATH_CARS_BOOK_CONFIRMATION = PATH_CARS_BOOK + "confirm/";
export const PATH_TRIPS = "trips";
export const PATH_DISRUPTION_EXERCISE_PDA = "disruption/exercise/";
export const PATH_PROFILE = "profile";
export const PATH_SIGNIN = "signin";
export const PATH_TERMS = PATH_HOME + "terms/";
export const PRICE_DROP_PROTECTION = PATH_TERMS + "price-drop-protection/";
export const BEST_PRICE_GUARANTEE = PATH_TERMS + "best-price-guarantee/";
export const PRICE_FREEZE = PATH_TERMS + "frozen-prices/";
export const PRICE_PREDICTION_PRICE_WATCH =
  PATH_TERMS + "price-prediction-price-watch/";
export const PATH_SITE_TERMS_OF_USE = PATH_HOME + "site-terms-of-use/";
export const PATH_AUTH = `auth/`;
export const PATH_AUTH_FTUX = `${PATH_AUTH}ftux/`;
export const PATH_AUTH_START_SESSION = `${PATH_AUTH}startsession/`;
export const PATH_AUTH_INVALID_SESSION = `${PATH_AUTH}invalidsession/`;
export const PATH_AUTH_LOGOUT = `${PATH_AUTH}logout/`;
export const PATH_LUXURY_HOTELS = PATH_HOME + "luxury-hotels/";
export const PATH_LUXURY_HOTELS_SEARCH = PATH_LUXURY_HOTELS + "search/";
export const PATH_EXCHANGE = `exchange`;
export const PATH_AGENT_IMPERSONATION = "impersonate/user/";
export const PATH_SUBSCRIPTION = "subscription";
export const PATH_AIRPORTS = "airports";
export const PATH_HOTEL_NIGHTS = "hotel-nights";
export const PATH_SUPPORT_CHAT = "support/chat";

export const PATH_GEN_AUTH = `/api/v0/auth/`;
export const PATH_GEN_AUTH_START_SESSION = `${PATH_GEN_AUTH}startSession`;

export const HIDDEN_FOOTER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const NO_FOOTER_PADDING_PATHS: string[] = [];

export const NO_FOOTER_PADDING_UNPROTECTED_PATHS: string[] = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const DISPLAY_HOMEPAGE_TAKEOVER_PATHS = [
  PATH_FLIGHTS,
  PATH_HOTELS,
  PATH_CARS,
  PATH_HOME,
];

export const HIDDEN_FOOTER_SEARCH_MOBILE = [
  PATH_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_CARS_SEARCH,
  PATH_LUXURY_HOTELS_SEARCH,
  PATH_TRIPS,
  PATH_FLIGHTS_BOOK,
];

export const UNPROTECTED_PATHS = [
  PATH_AUTH,
  // PATH_TERMS,
  // PATH_TERMS_OF_SERVICE,
  // PATH_SITE_TERMS_OF_USE,
  // PRICE_DROP_PROTECTION,
  // BEST_PRICE_GUARANTEE,
  // PRICE_PREDICTION_PRICE_WATCH,
  // PRICE_FREEZE,
];

export const HIDDEN_HEADER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const HIDDEN_BANNER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
  ...UNPROTECTED_PATHS,
];

export const apiVersionPrefix = "/api/v0";

export const fetchUserInfoPath = `${apiVersionPrefix}/user/getInfo`;
export const analyticsApiPrefix = `${apiVersionPrefix}/tracking`;
export const rewardsApiPrefix = `${apiVersionPrefix}/rewards`;

export const experimentsApiPrefix = `${apiVersionPrefix}/experiments`;
export const takeoversApiPrefix = `${apiVersionPrefix}/takeovers`;

export const apiConfig: IApiConfig = {
  experimentsApiPrefix,
  rewardsApiPrefix,
  takeoversApiPrefix,
  analyticsApiPrefix,
  fetchUserInfoPath,
};

export const isConcierge = () =>
  typeof window !== "undefined" && window.location.origin.includes("concierge");
